<template lang="pug">
  div
    .spinner__container
      template(v-if='isLoading')
        img.spinner__img(src='@/assets/images/icons/lazy-load-spinner.gif', alt='loading...')
    .detector(
      v-observe-visibility=`{
        callback: (isVisible) => this.updateFunction(isVisible),
        throttle: 300
    }`)
</template>

<script>
import { ObserveVisibility } from 'vue-observe-visibility';

export default {
  props: {
    isLoading: Boolean,
    update: {
      type: Function,
      default: () => console.log('update')
    }
  },

  data() {
    return {
      loading: this.isLoading
    };
  },

  methods: {
    updateFunction(isVisible) {
      if (isVisible && !this.isLoading) {
        this.update();
      }
    }
  },

  directives: {
    ObserveVisibility
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/core.scss';
.spinner {
  &__container {
    height: 30px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__img {
    height: 25px;
    width: 25px;
  }
}
.detector {
  height: 1px;
  width: 100%;
}
</style>
